const images = {
	// landing page
	paynowImg: 'images/pay-icon.svg',
	menuImg: 'images/menu.svg',
	homeImg: 'images/home.svg',
	noDataImg: 'images/no-data.svg',
	c_paytmCreds: 'images/paytm.svg',
	c_razorpayCreds: 'images/razor.svg',
	c_bankDetails: 'images/monoova.png',
	c_jiopayCreds: 'images/jiopay.png',
	calendar: 'images/calendar.svg',
	callImg: 'images/cabla.svg',
	search: 'images/search.svg',
	downArrow: 'images/down-arrow.svg',
	timePicker: 'images/time-picker.svg',
	success: 'images/success.gif',
	failed: 'images/failed.svg',
	close: 'images/close.svg',
	help: 'images/help.svg'
};

export default images;
